"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = exports.closedAt = exports.openAt = exports.visibleAt = undefined;

var _util = require("../../../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UTC = Util.Timestamp.UTC;
var visibleAt = exports.visibleAt = UTC(2017, "dec", 12);
var openAt = exports.openAt = UTC(2017, "dec", 15);
var closedAt = exports.closedAt = UTC(2017, "jan", 15);
var ruleset = exports.ruleset = {
  unlockZone6: true,
  twinMeatUpgrades: true
};
exports.default = [{
  name: "overlord",
  ruleset: ruleset,
  lifecycle: {
    visibleAt: visibleAt,
    openAt: openAt,
    //closedAt,
    migrateToLeague: "standard"
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L292ZXJsb3JkLmpzIl0sIm5hbWVzIjpbIlV0aWwiLCJVVEMiLCJUaW1lc3RhbXAiLCJ2aXNpYmxlQXQiLCJvcGVuQXQiLCJjbG9zZWRBdCIsInJ1bGVzZXQiLCJ1bmxvY2tab25lNiIsInR3aW5NZWF0VXBncmFkZXMiLCJuYW1lIiwibGlmZWN5Y2xlIiwibWlncmF0ZVRvTGVhZ3VlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7Ozs7QUFHWixJQUFNQyxNQUFNRCxLQUFLRSxTQUFMLENBQWVELEdBQTNCO0FBRU8sSUFBTUUsZ0NBQVlGLElBQUksSUFBSixFQUFVLEtBQVYsRUFBaUIsRUFBakIsQ0FBbEI7QUFDQSxJQUFNRywwQkFBU0gsSUFBSSxJQUFKLEVBQVUsS0FBVixFQUFpQixFQUFqQixDQUFmO0FBQ0EsSUFBTUksOEJBQVdKLElBQUksSUFBSixFQUFVLEtBQVYsRUFBaUIsRUFBakIsQ0FBakI7QUFDQSxJQUFNSyw0QkFBbUI7QUFDOUJDLGVBQWEsSUFEaUI7QUFFOUJDLG9CQUFrQjtBQUZZLENBQXpCO2tCQUlTLENBQ2Q7QUFDRUMsUUFBTSxVQURSO0FBRUVILGtCQUZGO0FBR0VJLGFBQVc7QUFDVFAsd0JBRFM7QUFFVEMsa0JBRlM7QUFHVDtBQUNBTyxxQkFBaUI7QUFKUjtBQUhiLENBRGMsQyIsImZpbGUiOiJvdmVybG9yZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi8uLi8uLi91dGlsXCJcbmltcG9ydCB0eXBlIHtTdGF0ZSBhcyBMZWFndWV9IGZyb20gXCIuLi9yYXdcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIFJ1bGVzZXR9IGZyb20gXCIuLi9ydWxlc2V0c1wiXG5jb25zdCBVVEMgPSBVdGlsLlRpbWVzdGFtcC5VVENcblxuZXhwb3J0IGNvbnN0IHZpc2libGVBdCA9IFVUQygyMDE3LCBcImRlY1wiLCAxMilcbmV4cG9ydCBjb25zdCBvcGVuQXQgPSBVVEMoMjAxNywgXCJkZWNcIiwgMTUpXG5leHBvcnQgY29uc3QgY2xvc2VkQXQgPSBVVEMoMjAxNywgXCJqYW5cIiwgMTUpXG5leHBvcnQgY29uc3QgcnVsZXNldDogUnVsZXNldCA9IHtcbiAgdW5sb2NrWm9uZTY6IHRydWUsXG4gIHR3aW5NZWF0VXBncmFkZXM6IHRydWUsXG59XG5leHBvcnQgZGVmYXVsdCAoW1xuICB7XG4gICAgbmFtZTogXCJvdmVybG9yZFwiLFxuICAgIHJ1bGVzZXQsXG4gICAgbGlmZWN5Y2xlOiB7XG4gICAgICB2aXNpYmxlQXQsXG4gICAgICBvcGVuQXQsXG4gICAgICAvL2Nsb3NlZEF0LFxuICAgICAgbWlncmF0ZVRvTGVhZ3VlOiBcInN0YW5kYXJkXCIsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/list/overlord.js
// module id = 362
// module chunks = 0